// utils/unityBridge.js

class UnityBridge {
  constructor() {
    // 定义 Unity 调 H5 时的回调
    window.receiveFromUnity = this._onReceiveFromUnity.bind(this);
    this.handlers = {};
  }

  /**
   * 注册事件处理器
   * @param {string} type - 消息类型
   * @param {function} callback - 回调函数
   */
  on(type, callback) {
    this.handlers[type] = callback;
  }

  /**
   * 取消事件处理器
   */
  off(type) {
    delete this.handlers[type];
  }

  /**
   * 发送消息给 Unity
   * @param {string} type - 消息类型
   * @param {any} payload - 消息内容
   */
  send(sendData) {
    const json = JSON.stringify(sendData);
    const scheme = "uniwebview://action?" + encodeURIComponent(json);
    console.log("📤 JSON 数据:", json);
    console.log("📤 [模拟发送给 Unity]:", scheme);

    if (process.env.NODE_ENV === "development") {
      // 开发环境下打印，不跳转
    } else {
      // 真机环境下才走 Scheme
      window.location.href = scheme;
    }
    // window.location.href = scheme;
  }

  /**
   * Unity 调用 H5 的统一入口
   * @param {object} data - Unity 发来的 JSON
   */
  _onReceiveFromUnity(data) {
    console.log("📩 收到 Unity 消息：", data);
    // const { type, msg, payload } = data;
    // const handler = this.handlers[type];
    // if (handler) {
    //   handler(payload || msg);
    // } else {
    console.warn(`未处理的 Unity `, data);
    // }
  }
}

export default new UnityBridge();
